import React, {Fragment, useState} from 'react';
import {Breadcrumbs, Button, ButtonGroup, IconButton, Link, Stack, Typography, useMediaQuery} from "@mui/material";
import {Camera, Download, Info, Leaderboard, LiveTv} from "@mui/icons-material";
import {useNavigate, useSearchParams} from "react-router-dom";
import DOC_file from "../../assets/karta_dokumentacyjna_domku_legowego_1_kuznia_raciborska.doc";
export const TopBar = () => {
    const [params, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [hovered, setHovered] = useState(false);
    const CAMERAS_PARAM = "cameras";
    const CHARTS_PARAM = "charts";
    const isMobile = useMediaQuery('(max-width:768px)');

    const getBirdhouseId = () => {
        return params ? params.get("id") : undefined;
    }

    const isView = (view) => {
        return params ? params.get("view") === view : "";
    }

    const setView = (view) => {
        const newParams = new URLSearchParams(params);
        newParams.set('view', view);

        setSearchParams(newParams);
    }

    const navigateToMainPanel = () => {
        navigate("/");
    }

    return <Fragment>
        <div style={{position: 'fixed', width: "100%", zIndex: 9999}}>
            <Stack direction="row" spacing={1} justifyContent={isMobile ? 'center' : 'space-between'} alignItems="center" sx={(theme) => ({
                background: "white",
                borderBottomColor: theme.palette.secondary.light,
                borderBottomStyle: "solid",
                borderWidth: "1px",
                maxWidth: "100%",
                height: "60px",
                px: "50px",
            })}>
                <Stack onClick={navigateToMainPanel} direction="row"
                       alignItems="center" spacing={0}
                       style={{cursor: hovered ? 'pointer' : 'default',}}
                       onMouseEnter={() => setHovered(true)}
                       onMouseLeave={() => setHovered(false)}>
                    <LiveTv color="secondary" fontSize="large"/>
                    <Typography variant="h4" style={{fontWeight: "bolder"}}>okiem</Typography>
                    <Typography color="secondary" variant="h4">w</Typography>
                    <Typography variant="h4" style={{fontWeight: "bolder"}}>budce</Typography>
                </Stack>
                {!isMobile && <ButtonGroup variant="text">
                        {getBirdhouseId() && <>
                            <Button startIcon={<Camera/>} onClick={() => setView(CAMERAS_PARAM)}
                                    color={isView(CAMERAS_PARAM) ? "secondary" : "primary"}>
                                Kamerki
                            </Button>
                            <Button startIcon={<Leaderboard/>} onClick={() => setView(CHARTS_PARAM)}
                                    color={isView(CHARTS_PARAM) ? "secondary" : "primary"}>
                                Wykresy
                            </Button>
                        </>}
                        <Button startIcon={<Info/>} onClick={() => navigate("/about")}
                                color={"primary"}>
                            O Projekcie
                        </Button>
                        <Button startIcon={<Download/>} onClick={() => {
                            const link = document.createElement('a');
                            link.href = DOC_file;
                            link.download = 'karta_dokumentacyjna_domku_legowego_1_kuznia_raciborska.doc';
                            link.click();
                        }}
                                color="primary">
                            Do pobrania
                        </Button>
                    </ButtonGroup>}
            </Stack>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" sx={(theme) => ({
                background: theme.palette.secondary.light,
                borderBottomColor: theme.palette.secondary.light,
                borderBottomStyle: "solid",
                borderWidth: "1px",
                width: "100%",
                height: "30px",
            })}>
                <Breadcrumbs aria-label="breadcrumb" color="white">
                    <Typography>LIVE</Typography>
                    <Link underline="hover" color="inherit" href="/">
                        BUDKI
                    </Link>
                    {getBirdhouseId() && <Typography>Nr {getBirdhouseId()})</Typography>}
                </Breadcrumbs>
            </Stack>
        </div>
        {isMobile && <Stack width="100%" direction="row" alignItems="center" justifyContent="space-around" sx={(theme) => ({ background: 'white', position: 'fixed', bottom: 0, left: 0, right: 0, height: '50px', borderTopColor: 'rgba(0, 0, 0, 0.12)',
            borderTopStyle: "solid",
            borderWidth: "0.5px"})}>
            {getBirdhouseId() && <>
                <IconButton onClick={() => setView(CAMERAS_PARAM)}
                            color={isView(CAMERAS_PARAM) ? "secondary" : "primary"}>
                    <Camera />
                </IconButton>
                <IconButton onClick={() => setView(CHARTS_PARAM)}
                            color={isView(CHARTS_PARAM) ? "secondary" : "primary"}>
                    <Leaderboard />
                </IconButton>
            </>}
            <IconButton onClick={() => navigate("/about")}
                         color={"primary"}>
                <Info />
            </IconButton>
            <IconButton color="primary" onClick={() => {
                const link = document.createElement('a');
                link.href = DOC_file;
                link.download = 'karta_dokumentacyjna_domku_legowego_1_kuznia_raciborska.doc';
                link.click();
            }}>
                <Download />
            </IconButton>
        </Stack>}
    </Fragment>
}
